import { router } from "@/app/router.ts";
import { computed } from "vue";
import { useHasAccess } from "@/shared/access-control/composables/use-has-access.ts";
import { AccessAction, AccessResource } from "@/shared/access-control/access-control.ts";
import { useI18n } from "vue-i18n";
import { MenuComponentEntry, MenuTextEntry } from "@/shared/components/menu/menu.model.ts";

export const useMechanicListMenuEntries = () => {
    const { t } = useI18n();
    const { hasAccess: hasDataDisplayConfigsAccess } = useHasAccess({
        resource: AccessResource.data_display_configs,
        action: AccessAction.write,
    });

    const menuEntries = computed<(MenuTextEntry | MenuComponentEntry)[]>(() => {
        return [
            {
                id: "configure-view",
                text: t("shared.Configure view"),
                icon: "fa-regular fa-sliders-simple icon-color",
                click: () => {
                    const route = router.resolve({ path: "/admin/datadisplay/parts" });
                    window.open(route.href, "_blank");
                },
                elementAttrs: { "data-qs": "partslist-settings-toolbar-item-display-configuration-button" },
                visible: hasDataDisplayConfigsAccess.value,
            },
        ];
    });

    return { menuEntries };
};
